function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.009 1.112c1.41.004 2.665.894 3.135 2.223h3.535c1.841 0 3.334 1.493 3.334 3.335v22.232c0 1.842-1.493 3.335-3.334 3.335H8.893c-1.842 0-3.335-1.493-3.335-3.335V6.67c0-1.842 1.493-3.335 3.335-3.335h3.535c.47-1.33 1.725-2.22 3.134-2.223zm-7.781 4.446H8.893c-.614 0-1.112.498-1.112 1.112v22.232c0 .614.498 1.111 1.112 1.111h17.786c.613 0 1.111-.497 1.111-1.111V6.67c0-.614-.498-1.112-1.111-1.112h-3.335v2.223H12.228V5.558zm5.558 15.563v2.223h-5.558V21.12h5.558zm5.558-4.447v2.223H12.228v-2.223h11.116zm-3.335-13.34h-4.447c-.613 0-1.111.499-1.111 1.112v1.112h6.67V4.446c0-.613-.498-1.111-1.112-1.111z",
  transform: "translate(-261 -2806) translate(261.714 2806.429)"
}))));

var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information.f29a658d.svg";
export { ForwardRef as ReactComponent };